<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Vendor"
    size="lg"
    @on-hide="resetFormData"
  >
    <vendors-form
      v-bind="value"
      @on-submit="updateVendor"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import VendorsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'VendorsEditModal',
  mixins: [formModalMixin],
  components: {
    VendorsForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: 'vendor-edit-modal',
    };
  },
  methods: {
    updateVendor(data, handleUpdate) {
      handleUpdate(this.$vendorsAPI.update(this.$route.params.id, data));
    },
    onSave(vendor) {
      this.closeModal();
      this.$emit('input', vendor);
    },
  },
};
</script>
